<script>
import Pagination from "@/components/_Shared/Pagination";
import { mapState } from "vuex";

export default {
  components: {
    Pagination
  }
};
</script>

<template>
  <div class="box">
    <div class="title">assinaturas</div>

    <div class="buttons-filters">
      <div>
        <router-link to="nova-assinatura" class="new-group">
          <img src="../../../static/plus.svg"> Criar pedido
        </router-link>
      </div>

      <div class="search">
        <input type="text" placeholder="buscar" class="with-icon icon-search sm">
        <button class="btn bg-white-purple ml-10">busca avançada</button>
      </div>
    </div>

    <div class="table">
      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Tipo</th>
            <th>Dia</th>
            <th>Frequência</th>
            <th>Cliente</th>
            <th>Diarista</th>
            <th>Duração</th>
            <th>Início</th>
            <th>Endereço</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td class="text-center">
              <img src="../../../static/icon_subscription_status_normal.svg" height="23px">
            </td>
            <td>B2B</td>
            <td>
              <ul class="day-of-week">
                <li>D</li>
                <li>S</li>
                <li>T</li>
                <li class="active">Q</li>
                <li>Q</li>
                <li>S</li>
                <li>S</li>
              </ul>
            </td>
            <td>
              <div class="frequency">semanal</div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>4 horas</td>
            <td>7:00</td>
            <td>Rua das Flores, 365 - ap304</td>
            <td>
              <div class="btn btn-small bg-purple-outline">ver mais</div>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <img src="../../../static/icon_subscription_status_paused.svg" height="23px">
            </td>
            <td>B2B</td>
            <td>
              <ul class="day-of-week">
                <li>D</li>
                <li>S</li>
                <li>T</li>
                <li class="active">Q</li>
                <li>Q</li>
                <li>S</li>
                <li>S</li>
              </ul>
            </td>
            <td>
              <div class="frequency">semanal</div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>4 horas</td>
            <td>7:00</td>
            <td>Rua das Flores, 365 - ap304</td>
            <td>
              <div class="btn btn-small bg-purple-outline">ver mais</div>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <img src="../../../static/icon_subscription_status_normal.svg" height="23px">
            </td>
            <td>B2B</td>
            <td>
              <ul class="day-of-week">
                <li>D</li>
                <li>S</li>
                <li>T</li>
                <li class="active">Q</li>
                <li>Q</li>
                <li>S</li>
                <li>S</li>
              </ul>
            </td>
            <td>
              <div class="frequency">semanal</div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>4 horas</td>
            <td>7:00</td>
            <td>Rua das Flores, 365 - ap304</td>
            <td>
              <div class="btn btn-small bg-purple-outline">ver mais</div>
            </td>
          </tr>
          <tr>
            <td class="text-center">
              <img src="../../../static/icon_subscription_status_normal.svg" height="23px">
            </td>
            <td>B2B</td>
            <td>
              <ul class="day-of-week">
                <li>D</li>
                <li>S</li>
                <li>T</li>
                <li class="active">Q</li>
                <li>Q</li>
                <li>S</li>
                <li>S</li>
              </ul>
            </td>
            <td>
              <div class="frequency">semanal</div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>
              <div class="with-image">
                <img src="../../../static/profile.png"> Maria
              </div>
            </td>
            <td>4 horas</td>
            <td>7:00</td>
            <td>Rua das Flores, 365 - ap304</td>
            <td>
              <div class="btn btn-small bg-purple-outline">ver mais</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination/>
  </div>
</template>

<style scoped>
.day-of-week {
  display: flex;
  flex-direction: row;
  padding: 0;
}

.day-of-week li {
  width: 23px;
  height: 23px;
  border-radius: 100%;
  background-color: #ddd;
  color: #8c8c8c;
  list-style: none;
  line-height: 23px;
  text-align: center;
  font-size: 10px;
  margin: 0 1px;
  font-weight: 300;
}

.day-of-week li.active {
  background-color: var(--purple);
  color: #fff;
}

.frequency {
  height: 23px;
  font-size: 10px;
  background-color: #ddd;
  color: #8c8c8c;
  border-radius: 23px;
  padding: 0 10px;
  text-align: center;
  line-height: 23px;
  font-weight: 300;
}

@media (max-width: 480px) {
  .search {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/Subscriptions.vue